var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "#fff",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.67.571a3.177 3.177 0 1 0 0 6.354 3.177 3.177 0 0 0 0-6.354M3.766 3.748a1.906 1.906 0 1 1 3.812 0 1.906 1.906 0 0 1-3.812 0M3.13 7.56c-.843 0-1.651.335-2.247.931-.659.659-.712 1.516-.45 2.238.253.702.811 1.328 1.488 1.7q.152.084.305.155c1.187.552 2.305.844 3.445.844s2.258-.292 3.445-.844q.153-.072.305-.155c.677-.372 1.235-.998 1.489-1.7.26-.722.208-1.58-.45-2.238a3.18 3.18 0 0 0-2.247-.93zM1.781 9.39a1.9 1.9 0 0 1 1.347-.559h5.084c.505 0 .99.201 1.348.559q.352.353.154.907c-.14.388-.477.782-.907 1.019q-.12.066-.228.116c-1.063.495-1.997.726-2.909.726s-1.846-.231-2.909-.726a4 4 0 0 1-.228-.116c-.43-.237-.766-.631-.906-1.02-.134-.367-.081-.672.154-.906",
    clipRule: "evenodd"
  })));
};
export default SvgAccount;